module.exports = require('./lib/isemail');



/*****************
 ** WEBPACK FOOTER
 ** ./~/isemail/index.js
 ** module id = 898
 ** module chunks = 0
 **/